import Vue from 'vue'
import CripNotice from 'crip-vue-notice'
var numeral = require('numeral')
var moment = require('moment')
const ThaiBaht = require('thai-baht-text')
Vue.use(CripNotice)

Vue.mixin({
  methods: {
    checkUser () {
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token
        this.$store.state.user = JSON.parse(sessionStorage.user)
        if (sessionStorage.config) {
          this.$store.state.config = JSON.parse(sessionStorage.config)
        }
      } else {
        this.$router.push('/login')
      }
    },
    dateYearThai (date) {
      return moment(date).format('YYYY')
    },
    dateMonth (date) {
      return moment(date).format('YYYY-MM')
    },
    alert_msg (type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      })
    },
    dateFormat (date) {
      return moment(date).format('L')
    },
    dateFormatDMY (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    dateTimeFormat (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    dateFormatDMY2 (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    dateFormatMY (date) {
      return moment(date).format('MM/YYYY')
    },
    monthFormat (str) {
      switch (str) {
        case '01':
          return 'ม.ค'
        case '02':
          return 'ก.พ'
        case '03':
          return 'มี.ค'
        case '04':
          return 'เม.ย'
        case '05':
          return 'พ.ค'
        case '06':
          return 'มิ.ย'
        case '07':
          return 'ก.ค'
        case '08':
          return 'ส.ค'
        case '09':
          return 'ก.ย'
        case '10':
          return 'ต.ค'
        case '11':
          return 'พ.ย'
        default:
          return 'ธ.ค'
      }
    },
    monthYearFormat (str) {
      const date = str.split('-')
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0]
        case '02':
          return 'กุมภาพันธ์ ' + date[0]
        case '03':
          return 'มีนาคม ' + date[0]
        case '04':
          return 'เมษายน ' + date[0]
        case '05':
          return 'พฤษภาคม ' + date[0]
        case '06':
          return 'มิถุนายน ' + date[0]
        case '07':
          return 'กรกฎาคม ' + date[0]
        case '08':
          return 'สิงหาคม ' + date[0]
        case '09':
          return 'กันยายน ' + date[0]
        case '10':
          return 'ตุลาคม ' + date[0]
        case '11':
          return 'พฤศจิกายน ' + date[0]
        default:
          return 'ธันวาคม ' + date[0]
      }
    },
    numberFormat (str) {
      return numeral(str).format('0,0.00')
    },
    numberFormatold (str) {
      return numeral(str).format('0,0')
    },
    moneyText (str) {
      return ThaiBaht(str)
    },
    convert_vs (val) {
      var data = []
      var len = 3
      if (val.length > 3) {
        len = val.length
      }
      var vallen = val.length
      for (var i = 0; i < len; i++) {
        var v = val.split('')
        if (len - i === vallen) {
          var ss = len - i
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val)
            } else {
              if (len > val.length) {
                data.push(v[i - 1])
              } else {
                data.push(v[i])
              }
            }
          } else {
            data.push(v[i - 1])
          }
          vallen--
        } else {
          data.push('0')
        }
      }
      var versions = ''
      for (var l = 0; l < data.length; l++) {
        versions += data[l]
        if (l < data.length - 1) {
          versions += '.'
        }
      }
      return versions
    },
    getParam (param) {
      var url = new URL(window.location.href)
      var c = url.searchParams.get(param)
      return c
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/mixin.js